import { Constants } from '@pwc/pwc-deals-web-common';
import { Formik } from 'formik';
import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import useMobile from 'common/hooks/useMobile';
import { useTranslation } from 'react-i18next';
import { contentTypeAnalyses } from '../../../../common/components/proptypes/commonProptypes';
import AnalysisGroupsList from '../AnalysisGroupsList/AnalysisGroupsList.tsx';
import ShowForRole from '../../../security/ShowForRole';
import TagEditor from '../../../tagging/common/TagEditor/TagEditor';
import { selectAllTags } from '../../../analyses/analysisSlice';
import ViewAnalysisSourceLinks from '../../../analyses/common/ViewAnalysisSourceLinks/ViewAnalysisSourceLinks';
import './AnalysesGroupsView.scss';
import StructuredAnalysisErrorCard from '../../../analyses/structured-analysis/common/StructuredAnalysisErrorCard/StructuredAnalysisErrorCard';

const AnalysesGroupsView = ({
  projectId,
  isKFAsPage,
  isCustomPage,
  isNonePage,
}) => {
  const isMobile = useMobile();
  const [tagFilters, setTagFilters] = useState([]);
  const [tags, setTags] = useState([]);
  const [showApiError, setShowApiError] = useState(false);
  const { t } = useTranslation();

  const allTags = useSelector(selectAllTags);

  const updateTags = async (values) => {
    setTagFilters(values);
    const selectedTags = allTags.filter((tag) => values.includes(tag.text));
    if (selectedTags && selectedTags.length > 0) {
      const tagIds = selectedTags.map((val) => val.id);
      setTags(tagIds);
    } else {
      setTags([]);
    }
  };

  if (showApiError) {
    return (
      <div data-testid="analyses-group-view" className="analyses-group-view">
        <StructuredAnalysisErrorCard />
      </div>
    );
  }

  return (
    <Box
      sx={{
        px: isMobile ? '16px' : undefined,
      }}
    >
      <div data-testid="analyses-group-view" className="analyses-group-view">
        <div className="list-container-header">
          <h2 className="analyses-group-h2">{t('analyses')}</h2>

          <div className="list-container-header-source-links">
            <ShowForRole
              roles={Constants.USER_ROLE_GROUPS.INTERNAL_READWRITE}
              projectId={projectId}
              restrictedForRoleElement={
                <div data-testid="analysis-source-links-placeholder" />
              }
            >
              <ViewAnalysisSourceLinks toolTipDirection="left" />
            </ShowForRole>
          </div>
        </div>

        <Formik initialValues={{ tags: [] }}>
          {() => (
            <div className="analyses-groups-view">
              <TagEditor
                projectId={projectId}
                onSelect={updateTags}
                tagsRight
                title={false}
                subtitle={false}
                allowCreateTags={false}
                placeholderText={t('filterByTag')}
              />
            </div>
          )}
        </Formik>

        <div className="content">
          <div data-testid="analysis-groups-list-view">
            <AnalysisGroupsList
              contentType={contentTypeAnalyses}
              projectId={projectId}
              tags={tags}
              isFiltered={tagFilters.length > 0}
              isCustomPage={isCustomPage}
              isKFAsPage={isKFAsPage}
              isNonePage={isNonePage}
              setShowApiError={setShowApiError}
            />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default AnalysesGroupsView;
